import React from 'react';
import { LeftArrow, RightArrow } from "../Icons/Icons"
const CustomPagination = ({ totalPages, offset ,setOffset }) => {

  const handleLeftArrowClick = () => {
    if (offset > 0) {
      setOffset(offset - 1);
    }
  };

  const handleRightArrowClick = () => {
    if ((offset + 1) * 10 < totalPages) {
      setOffset(offset + 1);
    }
  };

  return (
    <div>
      <div>
        <div className="flex items-center">
          <div>{(offset + 1) * 10 - 9}-{(offset + 1) * 10} of {totalPages}</div>
          <div className='h-9 w-9 flex items-center justify-center cursor-pointer' onClick={handleLeftArrowClick}>
           <LeftArrow/>
          </div>
          <div className='h-9 w-9 flex items-center justify-center cursor-pointer' onClick={handleRightArrowClick}>
            <RightArrow/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomPagination;
